// extracted by mini-css-extract-plugin
export default {"container":"Alert_container__pdNcQ","fade_out":"Alert_fade_out__52h0S"};